export default "__VITE_ASSET__BWJf8HFr__"